var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-filter"},_vm._l((_vm.options),function(item){return _c('div',{key:item.value,class:['module-filter-item', item.value === _vm.active ? 'active' : ''],on:{"click":function($event){return _vm.onSelect(item.value)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }